import React from 'react';
import styled from 'styled-components/macro';
import { color } from 'styled-system';
import useDependencies from '../Hooks/useDependencies';
import { Button } from '../SubComponents/Buttons';
import { errorReducerActionTypes } from '../redusers/error-reducer';

const ConfirmButtonContainer = styled.div`
  display: flex;
  width: auto;
  height: auto;
  margin: 0 auto;
  margin-bottom: 32px;
  ${color}
`;

interface ConfirmButtonProps {
  dependencies: {
    key: string;
    value: any;
    clickable?: boolean;
    errorType?: errorReducerActionTypes;
  }[];
  onClick: () => void;
  onError?: (errorType: errorReducerActionTypes) => void;
  enabled?: boolean;
  loading?: boolean;
  children: React.ReactNode;
  id?: string;
}

let ConfirmButton = ({
  dependencies,
  onClick,
  onError,
  enabled = true,
  children,
  loading,
  id,
}: ConfirmButtonProps) => {
  const { checkDependencies, isDisabled } = useDependencies(dependencies);

  const handleClick = () => {
    checkDependencies()
      .then(() => onClick())
      .catch((dependency) => onError?.(dependency.errorType));
  };

  return (
    <ConfirmButtonContainer>
      <Button
        id={id}
        loading={loading}
        look="secondary"
        onClick={handleClick}
        disabled={!enabled || isDisabled || loading}
        size="big"
        variableWidth
      >
        {children}
      </Button>
    </ConfirmButtonContainer>
  );
};

export default ConfirmButton;
